import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import classNames from 'classnames';
import * as Actions from '../store/actions';
import * as NoteActions from 'main/components/note/store/actions';
import { FusePageCarded } from '@fuse';
import GraderHeader from './GraderHeader';
import { Card, CardContent, AppBar, Typography, Grid, Button, Tab, Tabs } from '@material-ui/core';
import TabPanelButtons from 'main/components/TabPanelButtons';
import GraderQuestion from './GraderQuestion';
import Note from 'main/components/note/Note';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },

    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
});

class QuizGrader extends Component {
    state = {
        student_quiz_id: 0,
        is_dialog_open:  false,
        current_tab:     0,
    }

    constructor(props) {
        super(props);

        this.state.student_quiz_id = this.props.match.params.student_quiz_id;
    }

    handleDialogOpen = () => {
        this.setState({
            ...this.state,
            is_dialog_open: !this.state.is_dialog_open
        });
    }

    componentDidMount = () => {
        this.props.getStudentQuiz(this.state.student_quiz_id);
        this.props.getNoteList('student_quiz', this.state.student_quiz_id);
    }

    handleSave = () => {
        const { quiz, studentQuiz, saveStudentGrades, auth } = this.props;
        const instructor_id = 0; // TEMP
        const auth_id = auth.user.data.auth_id;

        saveStudentGrades(studentQuiz, auth_id, true);
    }
    
    handleChangeTab = (event, value) => {
        this.setState({
            current_tab: value
        });
    }

    generatePageContent = () => {
        const { classes, quiz, studentQuiz } = this.props;
        const { current_tab } = this.state;
        
        switch(current_tab)
        {
            case(0):
            {
                return (
                    <GraderHeader
                        quiz={quiz}
                        studentQuiz={studentQuiz}
                        classes={classes}
                    />
                );
            }
            case(1):
            {
                const question_point_total = studentQuiz.studentQuestionList.reduce((total, student_question) => {
                    return Number(total) + Number(student_question.Score);
                }, []);
                
                return (
                    <React.Fragment>
                        <AppBar position="static">
                            <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                <Typography className="h1 pr-16" color="inherit">Quiz Questions</Typography>

                                <Typography className="h3 pr-16" color="inherit">
                                    Current Score: {Number(question_point_total).toFixed(1) + " / " + Number(quiz.header.TotalScore).toFixed(1)}
                                </Typography>
                            </div>
                        </AppBar>
                        {quiz.questionList.map((question) => {
                            let studentQuestion = studentQuiz.studentQuestionList.filter((student_question) => student_question.question_id === question.header.question_id)[0];

                            if (typeof studentQuestion === 'undefined') {
                                studentQuestion = {
                                    question_id:       question.header.question_id,
                                    answer_id:         0,
                                    AnswerText:        '',
                                    Score:             0.00,
                                    studentAnswerList: [],
                                }
                            }

                            return (
                                <GraderQuestion
                                    key={question.header.question_id}
                                    question={question}
                                    studentQuestion={studentQuestion}
                                    classes={classes}
                                />
                            );
                        })}
                    </React.Fragment>
                );
                
            }

            default: {}
        }
    }

    render() {
        const { classes, quiz, studentQuiz } = this.props;
        const { current_tab } = this.state;
        const page_content = this.generatePageContent();

        if(studentQuiz.header.student_quiz_id === 0) {
            return (<div>Loading...</div>);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Quiz Grader</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Answers"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name = {"quiz"}
                                view_type      = {"edit"}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "grade",
                                        onClick:  this.handleSave,
                                    },
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <div className="p-24">
                        {page_content}
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentQuiz:    Actions.getStudentQuiz,
        saveStudentGrades: Actions.saveStudentGrades,
        getNoteList:       NoteActions.getNoteList,
    }, dispatch);
}

function mapStateToProps({ quizApp, auth }) {
    return {
        quiz:          quizApp.quizzes.currentQuiz,
        studentQuiz:   quizApp.quizScore.studentQuiz,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizGrader)));




// WEBPACK FOOTER //
// src/main/content/quiz/quizGrader/QuizGrader.js